module.exports = __webpack_public_path__ + "static/media/service1.e48c5b23.svg";